module.exports = __webpack_public_path__ + "img/算法定义统计.7aeb9c9c.svg";